var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5953_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 7.5835C12.6786 7.5835 12.5302 7.64495 12.4208 7.75435C12.3114 7.86375 12.25 8.01212 12.25 8.16683V10.6244C12.2495 11.0554 12.0781 11.4687 11.7733 11.7735C11.4685 12.0783 11.0553 12.2497 10.6242 12.2502H3.37573C2.9447 12.2497 2.53145 12.0783 2.22666 11.7735C1.92188 11.4687 1.75044 11.0554 1.74998 10.6244V8.16683C1.74998 8.01212 1.68852 7.86375 1.57913 7.75435C1.46973 7.64495 1.32136 7.5835 1.16665 7.5835C1.01194 7.5835 0.863564 7.64495 0.754167 7.75435C0.644771 7.86375 0.583313 8.01212 0.583313 8.16683V10.6244C0.584085 11.3648 0.878533 12.0746 1.40205 12.5981C1.92556 13.1216 2.63537 13.4161 3.37573 13.4168H10.6242C11.3646 13.4161 12.0744 13.1216 12.5979 12.5981C13.1214 12.0746 13.4159 11.3648 13.4166 10.6244V8.16683C13.4166 8.01212 13.3552 7.86375 13.2458 7.75435C13.1364 7.64495 12.988 7.5835 12.8333 7.5835Z",
    fill: "#F37D53",
    stroke: "#F37D53",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91241 5.07912L6.41666 2.57487V9.5C6.41666 9.65471 6.47812 9.80308 6.58751 9.91248C6.69691 10.0219 6.84528 10.0833 6.99999 10.0833C7.1547 10.0833 7.30308 10.0219 7.41247 9.91248C7.52187 9.80308 7.58333 9.65471 7.58333 9.5V2.57487L10.0876 5.07912C10.1976 5.18538 10.3449 5.24418 10.4979 5.24285C10.6508 5.24152 10.7971 5.18017 10.9053 5.07202C11.0135 4.96386 11.0748 4.81755 11.0761 4.66461C11.0775 4.51166 11.0187 4.36431 10.9124 4.25429L7.41241 0.754288C7.30302 0.64493 7.15467 0.583496 6.99999 0.583496C6.84531 0.583496 6.69697 0.64493 6.58758 0.754288L3.08758 4.25429C2.98132 4.36431 2.92252 4.51166 2.92385 4.66461C2.92518 4.81755 2.98653 4.96386 3.09468 5.07202C3.20284 5.18017 3.34914 5.24152 3.50209 5.24285C3.65504 5.24418 3.80239 5.18538 3.91241 5.07912Z",
    fill: "#F37D53",
    stroke: "#F37D53",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5953_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/Upload-icon.84c3a8c0c2aa3cd599222df5461c8980.svg";
export { ForwardRef as ReactComponent };